const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class PairWith extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (
      this.els?.slide?.exists === false ||
      this.els.slide.elements.length === 1
    ) {
      return
    }

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: this.els.slide.elements.length > 2 ? 2.5 : 2,
          spacing: 5,
        },
        breakpoints: {
          '(max-width: 1200px)': {
            slides: {
              perView: 1.5,
              spacing: 5,
            },
          },
          '(max-width: 767px)': {
            slides: {
              perView: this.els.slide.elements.length > 2 ? 2.5 : 2,
              spacing: 5,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
          arrows: this.els?.arrows?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('pair-with')) {
  customElements.define('pair-with', PairWith)
}
